export class NewsViewModel {
  id: number;
  title: string;
  link: string;
  image: string;
  imageSrc: string;
  date: Date;
  excerpt: string;
  featured: boolean;
  showNewsSidebar: boolean;
}

export class News extends NewsViewModel {
  constructor(data?: NewsViewModel) {
    super();
    Object.assign(this, data);
  }
}
